import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import { isNumber } from '@pct-ts/typeguard';

@Pipe({
  name: 'isNumber',
})
export class IsNumberPipe implements PipeTransform {
  transform(value: unknown): value is number {
    return isNumber(value);
  }
}
